import React from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';

export function HomeSkeleton() {
  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Banner Skeleton */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={500}
        sx={{ bgcolor: 'action.hover', mb: 4 }}
      />

      <Container maxWidth="lg">
        {/* Quick Access Section */}
        <Box sx={{ mb: 6 }}>
          <Skeleton variant="text" width={200} height={40} sx={{ mb: 3 }} />
          <Grid container spacing={3}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={6} sm={3} key={`quick-${item}`}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                  }}
                >
                  <Skeleton variant="circular" width={80} height={80} />
                  <Skeleton variant="text" width={100} height={24} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Important Links Section */}
        <Box sx={{ mb: 6 }}>
          <Skeleton variant="text" width={200} height={40} sx={{ mb: 3 }} />
          <Grid container spacing={3}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} sm={6} md={3} key={`link-${item}`}>
                <Box
                  sx={{
                    p: 3,
                    borderRadius: 2,
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                  }}
                >
                  <Skeleton variant="circular" width={48} height={48} />
                  <Skeleton variant="text" width="80%" height={24} />
                  <Skeleton variant="text" width="60%" height={20} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* News Highlights Section */}
        <Box sx={{ mb: 6 }}>
          <Skeleton variant="text" width={200} height={40} sx={{ mb: 3 }} />
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={400}
                sx={{ borderRadius: 2, bgcolor: 'action.hover' }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Skeleton variant="rectangular" width={100} height={30} sx={{ borderRadius: 2 }} />
                <Skeleton variant="text" width="90%" height={40} />
                <Skeleton variant="text" width="95%" height={24} />
                <Skeleton variant="text" width="85%" height={24} />
                <Skeleton variant="text" width="70%" height={24} />
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                  <Skeleton variant="rectangular" width={180} height={40} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
